export const PROFILE_FORM_UPDATE = 'PROFILE_FORM_UPDATE';
export const PROFILE_FORM_UPDATE_TIME_SLOT = 'PROFILE_FORM_UPDATE_TIME_SLOT';
export const PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT = 'PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT';
export const PROFILE_FORM_UPDATE_ADD_TIME_SLOT = 'PROFILE_FORM_UPDATE_ADD_TIME_SLOT'
export const PROFILE_FORM_SET_ACTIVE_TAB = 'PROFILE_FORM_SET_ACTIVE_TAB';
export const PROFILE_FORM_SET_PROFILE = 'PROFILE_FORM_SET_PROFILE';
export const PROFILE_FORM_RESET = 'PROFILE_FORM_RESET';

export const updateProfileForm = (e) => {
  const payload = {
    [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  }

  if (e.target.name === "als_mode_enabled" && e.target.checked) {
   payload.astro_clock = false;
  }
  if (e.target.name === "astro_clock" && e.target.checked) {
   payload.als_mode_enabled = false;
  }

  return {
    type: PROFILE_FORM_UPDATE,
    payload,
  };
}

export const setProfile = (profile) => ({
  type: PROFILE_FORM_SET_PROFILE,
  profile
});

export const updateTimeSlot = (day, time, field, value) => ({
  type: PROFILE_FORM_UPDATE_TIME_SLOT,
  day: day,
  time: time,
  payload: {
    [field]: value
  }
});

export const reset = () => ({
  type: PROFILE_FORM_RESET
})

export const removeTimeSlot = (day, time) => ({
  type: PROFILE_FORM_UPDATE_REMOVE_TIME_SLOT,
  day,
  time
})

export const addTimeSlot = (day, time, low, high) => ({
  type: PROFILE_FORM_UPDATE_ADD_TIME_SLOT,
  day,
  time,
  low,
  high
})

export const setActiveTab = (tab) => ({
  type: PROFILE_FORM_SET_ACTIVE_TAB,
  tab
});



// WEBPACK FOOTER //
// ./src/actions/profileForm.js